import React from 'react';
import Streamer from './Streamer'

function Streamrs({ data, type = "" }) {

  let filtedData = type ? data.filter((item) => item.game_name === type) : data

  return <div className='w-9/12 m-auto flex flex-wrap justify-center'>
    {filtedData.map((stream) => {
      return <Streamer key={stream.id} data={stream} />
    })}
  </div>
}

export default Streamrs;
